// extracted by mini-css-extract-plugin
export default {"periodGrid":"StatCards_periodGrid__RD0tz"};